import React, { useState, useEffect, useCallback } from 'react';
// GoogleMap components now in MapScreen.jsx
import './App.css';

// Import the new FoodScreen and DhabaRegistrationForm components
import { FoodScreen, DhabaRegistrationForm, DhabaDetailScreen, OwnerDashboard, MapScreen, PreOrderScreen, AdminPanel, SplashScreen, PlaceholderScreen, MyProfileScreen, MyTripsScreen, MyOrdersScreen, EmergencyScreen } from './screens';

// Import LocationProvider and useLocation
import { LocationProvider, useLocation } from './store';

// Import LocationSearchBar component
import { LocationSearchBar, ActiveOrdersCard } from './components/common';

// Google Maps API Key
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Dummy restaurant data
const restaurants = [
  {
    id: '1',
    name: 'Punjab Da Dhaba',
    image: 'https://images.unsplash.com/photo-1708517194326-6077b788f04b?w=400',
    rating: 4.5,
    reviewCount: 342,
    cuisine: 'North Indian • Punjabi',
    distance: '2.3 km',
    time: '15 min',
    isOpen: true,
    price: '₹₹',
    address: 'NH-48, Near Toll Plaza, Manesar',
    tags: ['Pure Veg', 'Family Friendly', 'Parking'],
  },
  {
    id: '2',
    name: 'Highway King Restaurant',
    image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400',
    rating: 4.2,
    reviewCount: 518,
    cuisine: 'Multi-cuisine • Fast Food',
    distance: '5.1 km',
    time: '20 min',
    isOpen: true,
    price: '₹₹₹',
    address: 'Expressway Service Road, Jaipur Highway',
    tags: ['AC Dining', 'Parking', 'Card Accepted'],
  },
  {
    id: '3',
    name: 'Sher-e-Punjab',
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400',
    rating: 4.7,
    reviewCount: 892,
    cuisine: 'North Indian • Mughlai',
    distance: '8.4 km',
    time: '25 min',
    isOpen: true,
    price: '₹₹',
    address: 'GT Karnal Road, Sonipat',
    tags: ['Non-Veg', 'Bestseller', 'Clean Washrooms'],
  },
  {
    id: '4',
    name: 'Amrik Sukhdev Dhaba',
    image: 'https://images.unsplash.com/photo-1552566626-52f8b828add9?w=400',
    rating: 4.8,
    reviewCount: 2341,
    cuisine: 'Punjabi • Parathas',
    distance: '12.0 km',
    time: '30 min',
    isOpen: true,
    price: '₹',
    address: 'Murthal, NH-1, Sonipat',
    tags: ['Legendary', 'Open 24x7', 'Famous Parathas'],
  },
];

const menuItems = [
  { id: 'm1', name: 'Butter Chicken', price: 320, isVeg: false, bestseller: true, image: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=200' },
  { id: 'm2', name: 'Paneer Butter Masala', price: 260, isVeg: true, bestseller: true, image: 'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=200' },
  { id: 'm3', name: 'Aloo Paratha', price: 80, isVeg: true, bestseller: true, image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=200' },
  { id: 'm4', name: 'Dal Makhani', price: 220, isVeg: true, bestseller: false, image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=200' },
  { id: 'm5', name: 'Tandoori Chicken', price: 350, isVeg: false, bestseller: true, image: 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=200' },
];

// Indian Breakfast Menu with Service Providers
const breakfastMenu = [
  {
    id: 'b1',
    name: 'Aloo Paratha',
    description: 'Crispy wheat flatbread stuffed with spiced potatoes, served with butter & curd',
    image: 'https://images.unsplash.com/photo-1565557623262-b51c2513a641?w=400',
    isVeg: true,
    bestseller: true,
    providers: [
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 80, rating: 4.8, time: '15 min', distance: '50 km' },
      { id: 'p2', name: 'Punjab Da Dhaba', price: 70, rating: 4.5, time: '20 min', distance: '45 km' },
      { id: 'p3', name: 'Highway King', price: 90, rating: 4.2, time: '18 min', distance: '52 km' },
    ]
  },
  {
    id: 'b2',
    name: 'Chole Bhature',
    description: 'Spicy chickpea curry served with deep-fried fluffy bread',
    image: 'https://images.unsplash.com/photo-1626132647523-66f5bf380027?w=400',
    isVeg: true,
    bestseller: true,
    providers: [
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 120, rating: 4.8, time: '20 min', distance: '50 km' },
      { id: 'p4', name: 'Sher-e-Punjab', price: 110, rating: 4.7, time: '25 min', distance: '48 km' },
      { id: 'p2', name: 'Punjab Da Dhaba', price: 100, rating: 4.5, time: '22 min', distance: '45 km' },
    ]
  },
  {
    id: 'b3',
    name: 'Poori Sabzi',
    description: 'Deep-fried puffed bread served with spiced potato curry',
    image: 'https://images.unsplash.com/photo-1567337710282-00832b415979?w=400',
    isVeg: true,
    bestseller: false,
    providers: [
      { id: 'p2', name: 'Punjab Da Dhaba', price: 90, rating: 4.5, time: '18 min', distance: '45 km' },
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 100, rating: 4.8, time: '15 min', distance: '50 km' },
    ]
  },
  {
    id: 'b4',
    name: 'Masala Dosa',
    description: 'Crispy rice crepe filled with spiced potato, served with sambar & chutney',
    image: 'https://images.unsplash.com/photo-1668236543090-82eb5f1e1711?w=400',
    isVeg: true,
    bestseller: true,
    providers: [
      { id: 'p3', name: 'Highway King', price: 110, rating: 4.2, time: '20 min', distance: '52 km' },
      { id: 'p5', name: 'South Indian Corner', price: 95, rating: 4.6, time: '18 min', distance: '47 km' },
    ]
  },
  {
    id: 'b5',
    name: 'Idli Sambar',
    description: 'Steamed rice cakes served with lentil soup and coconut chutney',
    image: 'https://images.unsplash.com/photo-1589301760014-d929f3979dbc?w=400',
    isVeg: true,
    bestseller: false,
    providers: [
      { id: 'p5', name: 'South Indian Corner', price: 70, rating: 4.6, time: '15 min', distance: '47 km' },
      { id: 'p3', name: 'Highway King', price: 80, rating: 4.2, time: '18 min', distance: '52 km' },
    ]
  },
  {
    id: 'b6',
    name: 'Paneer Paratha',
    description: 'Wheat flatbread stuffed with spiced cottage cheese, served with pickle & curd',
    image: 'https://images.unsplash.com/photo-1604152135912-04a022e23696?w=400',
    isVeg: true,
    bestseller: true,
    providers: [
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 100, rating: 4.8, time: '18 min', distance: '50 km' },
      { id: 'p4', name: 'Sher-e-Punjab', price: 95, rating: 4.7, time: '20 min', distance: '48 km' },
      { id: 'p2', name: 'Punjab Da Dhaba', price: 90, rating: 4.5, time: '22 min', distance: '45 km' },
    ]
  },
  {
    id: 'b7',
    name: 'Omelette with Toast',
    description: 'Fluffy egg omelette with onion, tomato, green chilli served with buttered toast',
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    isVeg: false,
    bestseller: false,
    providers: [
      { id: 'p3', name: 'Highway King', price: 80, rating: 4.2, time: '12 min', distance: '52 km' },
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 70, rating: 4.8, time: '10 min', distance: '50 km' },
    ]
  },
  {
    id: 'b8',
    name: 'Lassi (Sweet/Salted)',
    description: 'Traditional Punjabi yogurt drink - choose sweet or salted',
    image: 'https://images.unsplash.com/photo-1626200925138-332f5ed47a9d?w=400',
    isVeg: true,
    bestseller: true,
    providers: [
      { id: 'p1', name: 'Amrik Sukhdev Dhaba', price: 60, rating: 4.8, time: '5 min', distance: '50 km' },
      { id: 'p2', name: 'Punjab Da Dhaba', price: 50, rating: 4.5, time: '5 min', distance: '45 km' },
      { id: 'p4', name: 'Sher-e-Punjab', price: 55, rating: 4.7, time: '5 min', distance: '48 km' },
    ]
  },
];

// Splash Screen - Premium Dark Theme
// SplashScreen extracted to screens/SplashScreen.jsx

// Auth Screen - Elegant White Theme
function AuthScreen({ onLogin }) {
  const [phone, setPhone] = useState('');
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [mockOtp, setMockOtp] = useState('');
  const [otpExpiresIn, setOtpExpiresIn] = useState(0);

  // Countdown timer for OTP expiry
  useEffect(() => {
    let timer;
    if (showOtp && otpExpiresIn > 0) {
      timer = setInterval(() => {
        setOtpExpiresIn(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showOtp, otpExpiresIn]);

  const handleSendOtp = async () => {
    if (phone.length !== 10) return;
    
    setLoading(true);
    setError('');
    
    try {
      const { sendOTP } = await import('./services/authService');
      const result = await sendOTP(phone);
      setShowOtp(true);
      setOtp('');
      if (result.mock_otp) {
        setMockOtp(result.mock_otp);
      }
      if (result.expires_in_minutes) {
        setOtpExpiresIn(result.expires_in_minutes * 60);
      }
    } catch (err) {
      setError(err.message || 'Failed to send OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    if (otp.length !== 6) return;
    
    setLoading(true);
    setError('');
    
    try {
      const { verifyOTP } = await import('./services/authService');
      const result = await verifyOTP(phone, otp);
      onLogin(result.user);
    } catch (err) {
      setError(err.message || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = () => {
    setOtp('');
    setError('');
    handleSendOtp();
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header - White with gold accents */}
      <div 
        className="pt-12 pb-10 px-6 text-center"
        style={{ background: '#FFFFFF' }}
      >
        {/* Logo - Symbol only */}
        <div style={{
          width: '120px',
          height: '120px',
          margin: '0 auto 20px auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img 
            src="/images/hiwaytrip-icon.png" 
            alt="HiWayTrip" 
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
        
        <h1 
          className="text-2xl font-bold"
          style={{ 
            fontFamily: "'Manrope', sans-serif",
            color: '#1A1A1A'
          }}
        >
          {showOtp ? 'Verify OTP' : 'Welcome to HiWayTrip'}
        </h1>
        <p style={{ marginTop: '8px', color: '#6B7280', fontSize: '14px' }}>
          {showOtp 
            ? `Enter the 6-digit code sent to +91 ${phone}` 
            : 'Your premium highway travel companion'
          }
        </p>
      </div>

      {/* Form Section */}
      <div className="flex-1 px-6 pt-4">
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm text-center">
            {error}
          </div>
        )}

        {!showOtp ? (
          <div className="space-y-6">
            <div>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#374151', 
                marginBottom: '8px' 
              }}>
                Phone Number
              </label>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                border: '2px solid #E5E7EB',
                borderRadius: '12px',
                overflow: 'hidden',
                background: '#FAFAFA'
              }}>
                <span style={{ 
                  padding: '16px', 
                  borderRight: '2px solid #E5E7EB', 
                  fontWeight: '600', 
                  color: '#1A1A1A',
                  background: '#F3F4F6'
                }}>+91</span>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="Enter your phone number"
                  style={{
                    flex: 1,
                    padding: '16px',
                    border: 'none',
                    outline: 'none',
                    fontSize: '16px',
                    background: 'transparent',
                    color: '#1A1A1A'
                  }}
                  data-testid="phone-input"
                />
              </div>
            </div>
            
            <button
              onClick={handleSendOtp}
              disabled={phone.length !== 10 || loading}
              style={{
                width: '100%',
                padding: '16px',
                borderRadius: '9999px',
                border: 'none',
                fontWeight: '600',
                fontSize: '16px',
                cursor: phone.length === 10 && !loading ? 'pointer' : 'not-allowed',
                background: phone.length === 10 && !loading 
                  ? 'linear-gradient(180deg, #E53935 0%, #1E88E5 100%)' 
                  : '#E5E7EB',
                color: phone.length === 10 && !loading ? '#FFFFFF' : '#9CA3AF',
                boxShadow: phone.length === 10 && !loading 
                  ? '0 4px 14px rgba(229, 57, 53, 0.3)' 
                  : 'none',
                transition: 'all 0.2s ease'
              }}
              data-testid="send-otp-btn"
            >
              {loading ? 'Sending...' : 'Send OTP'}
            </button>
            
            <p className="text-center text-sm" style={{ color: '#9CA3AF' }}>
              By continuing, you agree to our Terms & Privacy Policy
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {/* Demo Mode Banner with OTP */}
            {mockOtp && (
              <div style={{
                padding: '16px',
                background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, rgba(212, 175, 55, 0.08) 100%)',
                border: '2px solid rgba(212, 175, 55, 0.4)',
                borderRadius: '16px',
                textAlign: 'center'
              }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: '8px',
                  marginBottom: '8px'
                }}>
                  <span style={{ fontSize: '14px', color: '#92700C', fontWeight: '600' }}>🔐 Demo Mode</span>
                </div>
                <div style={{ 
                  fontSize: '28px', 
                  fontWeight: '800', 
                  letterSpacing: '8px',
                  color: '#1A1A1A',
                  fontFamily: "'Manrope', monospace",
                  padding: '8px 0'
                }}>
                  {mockOtp}
                </div>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#6B7280',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '4px'
                }}>
                  {otpExpiresIn > 0 ? (
                    <>
                      <span>Expires in</span>
                      <span style={{ 
                        fontWeight: '700', 
                        color: otpExpiresIn < 60 ? '#EF4444' : '#92700C' 
                      }}>
                        {formatTime(otpExpiresIn)}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: '#EF4444' }}>OTP expired. Please resend.</span>
                  )}
                </div>
              </div>
            )}
            
            <div>
              <label style={{ 
                display: 'block', 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#374151', 
                marginBottom: '16px',
                textAlign: 'center'
              }}>
                Enter OTP
              </label>
              <div className="flex justify-between gap-3">
                {[...Array(6)].map((_, i) => (
                  <input
                    key={i}
                    type="text"
                    maxLength={1}
                    value={otp[i] || ''}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      const newOtp = otp.split('');
                      newOtp[i] = val;
                      setOtp(newOtp.join(''));
                      if (val && e.target.nextSibling) e.target.nextSibling.focus();
                    }}
                    style={{
                      width: '48px',
                      height: '56px',
                      textAlign: 'center',
                      fontSize: '20px',
                      fontWeight: '700',
                      border: '2px solid #E5E7EB',
                      borderRadius: '12px',
                      background: '#FAFAFA',
                      outline: 'none',
                      color: '#1A1A1A',
                      fontFamily: "'Manrope', sans-serif",
                      transition: 'all 0.2s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#D4AF37';
                      e.target.style.boxShadow = '0 0 0 3px rgba(212, 175, 55, 0.2)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#E5E7EB';
                      e.target.style.boxShadow = 'none';
                    }}
                    data-testid={`otp-input-${i}`}
                  />
                ))}
              </div>
            </div>
            
            <button
              onClick={handleVerify}
              disabled={otp.length !== 6 || loading}
              style={{
                width: '100%',
                padding: '16px',
                borderRadius: '9999px',
                border: 'none',
                fontWeight: '600',
                fontSize: '16px',
                cursor: otp.length === 6 && !loading ? 'pointer' : 'not-allowed',
                background: otp.length === 6 && !loading 
                  ? 'linear-gradient(180deg, #E53935 0%, #1E88E5 100%)' 
                  : '#E5E7EB',
                color: otp.length === 6 && !loading ? '#FFFFFF' : '#9CA3AF',
                boxShadow: otp.length === 6 && !loading 
                  ? '0 4px 14px rgba(229, 57, 53, 0.3)' 
                  : 'none',
                transition: 'all 0.2s ease'
              }}
              data-testid="verify-otp-btn"
            >
              {loading ? 'Verifying...' : 'Verify & Continue'}
            </button>
            
            <div className="text-center space-y-3">
              <button 
                onClick={handleResendOtp}
                disabled={loading}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#D4AF37',
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                Resend OTP
              </button>
              
              <button
                onClick={() => { setShowOtp(false); setOtp(''); setError(''); }}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '12px',
                  background: 'none',
                  border: 'none',
                  color: '#6B7280',
                  fontWeight: '500',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                Change Phone Number
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// Restaurant Card
function RestaurantCard({ restaurant, onClick }) {
  return (
    <div onClick={onClick} className="bg-white rounded-2xl shadow-sm overflow-hidden cursor-pointer mb-4">
      <div className="relative">
        <img src={restaurant.image} alt={restaurant.name} className="w-full h-36 object-cover" />
        <span className={`absolute top-2 right-2 px-2 py-1 text-xs font-bold rounded ${restaurant.isOpen ? 'bg-green-600' : 'bg-red-600'} text-white`}>
          {restaurant.isOpen ? 'OPEN' : 'CLOSED'}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-1 text-xs font-medium bg-black/70 text-white rounded flex items-center gap-1">
          ⏱️ {restaurant.time}
        </span>
      </div>
      <div className="p-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-gray-900">{restaurant.name}</h3>
          <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold flex items-center gap-1">
            ⭐ {restaurant.rating}
          </span>
        </div>
        <p className="text-sm text-gray-500 mt-1">{restaurant.cuisine}</p>
        <div className="flex items-center gap-3 mt-2">
          <span className="text-sm font-medium flex items-center gap-1">
            <span className="text-primary">📍</span> {restaurant.distance}
          </span>
          <span className="text-sm font-semibold text-primary">{restaurant.price}</span>
        </div>
        <div className="flex flex-wrap gap-2 mt-3">
          {restaurant.tags.map((tag) => (
            <span key={tag} className="bg-primary/10 text-primary text-xs px-2 py-1 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

// Trip Planner Component
function TripPlanner({ onViewBreakfast }) {
  const [tripData, setTripData] = useState({
    dateOfJourney: '',
    startTime: '',
    startLocation: '',
    useCurrentLocation: false,
    destination: '',
    numberOfPersons: 2,
    vehicleNumber: '',
  });
  const [tripResult, setTripResult] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (field, value) => {
    setTripData({ ...tripData, [field]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      setTripResult({
        route: {
          distance: '450 km',
          duration: '6h 30min',
          via: 'NH-48 via Jaipur Highway',
          stops: ['Manesar', 'Dharuhera', 'Shahpura', 'Jaipur'],
        },
        breakfast: {
          name: 'Amrik Sukhdev Dhaba',
          location: 'Murthal, NH-1',
          time: '8:00 AM',
          distance: '50 km from start',
          rating: 4.8,
        },
        lunch: {
          name: 'Highway King Restaurant',
          location: 'Shahpura, NH-48',
          time: '1:00 PM',
          distance: '220 km from start',
          rating: 4.2,
        },
        dinner: {
          name: 'Sher-e-Punjab',
          location: 'Near Jaipur',
          time: '8:00 PM',
          distance: '400 km from start',
          rating: 4.7,
        },
        stay: {
          name: 'Hotel Highway Inn',
          location: 'Jaipur City Center',
          checkIn: '9:00 PM',
          price: '₹2,500/night',
          rating: 4.5,
        },
      });
      setIsSubmitting(false);
    }, 1500);
  };

  const resetTrip = () => {
    setTripResult(null);
    setTripData({
      dateOfJourney: '',
      startTime: '',
      startLocation: '',
      useCurrentLocation: false,
      destination: '',
      numberOfPersons: 2,
      vehicleNumber: '',
    });
  };

  if (tripResult) {
    return (
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900">Your Trip Plan</h2>
          <button 
            onClick={resetTrip}
            className="text-primary text-sm font-semibold"
          >
            Plan New Trip
          </button>
        </div>

        {/* Route Card */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm" data-testid="route-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <span className="text-xl">🛣️</span>
            </div>
            <div>
              <h3 className="font-bold text-gray-900">Your Route</h3>
              <p className="text-sm text-gray-500">{tripResult.route.via}</p>
            </div>
          </div>
          <div className="flex gap-4 text-sm">
            <span className="flex items-center gap-1"><span className="text-primary">📏</span> {tripResult.route.distance}</span>
            <span className="flex items-center gap-1"><span className="text-primary">⏱️</span> {tripResult.route.duration}</span>
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {tripResult.route.stops.map((stop, i) => (
              <span key={i} className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">
                {stop}
              </span>
            ))}
          </div>
        </div>

        {/* Breakfast Card */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm" data-testid="breakfast-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center">
              <span className="text-xl">🌅</span>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900">Breakfast</h3>
              <p className="text-sm text-primary font-medium">{tripResult.breakfast.name}</p>
            </div>
            <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">
              ⭐ {tripResult.breakfast.rating}
            </span>
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <p className="flex items-center gap-2"><span>📍</span> {tripResult.breakfast.location}</p>
            <p className="flex items-center gap-2"><span>⏰</span> {tripResult.breakfast.time}</p>
            <p className="flex items-center gap-2"><span>🚗</span> {tripResult.breakfast.distance}</p>
          </div>
          <button 
            onClick={() => onViewBreakfast && onViewBreakfast(tripResult.breakfast)}
            className="w-full mt-3 py-2 border border-primary text-primary rounded-lg text-sm font-semibold"
            data-testid="view-breakfast-details"
          >
            View Details
          </button>
        </div>

        {/* Lunch Card */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm" data-testid="lunch-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
              <span className="text-xl">☀️</span>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900">Lunch</h3>
              <p className="text-sm text-primary font-medium">{tripResult.lunch.name}</p>
            </div>
            <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">
              ⭐ {tripResult.lunch.rating}
            </span>
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <p className="flex items-center gap-2"><span>📍</span> {tripResult.lunch.location}</p>
            <p className="flex items-center gap-2"><span>⏰</span> {tripResult.lunch.time}</p>
            <p className="flex items-center gap-2"><span>🚗</span> {tripResult.lunch.distance}</p>
          </div>
          <button className="w-full mt-3 py-2 border border-primary text-primary rounded-lg text-sm font-semibold">
            View Details
          </button>
        </div>

        {/* Dinner Card */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm" data-testid="dinner-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
              <span className="text-xl">🌙</span>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900">Dinner</h3>
              <p className="text-sm text-primary font-medium">{tripResult.dinner.name}</p>
            </div>
            <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">
              ⭐ {tripResult.dinner.rating}
            </span>
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <p className="flex items-center gap-2"><span>📍</span> {tripResult.dinner.location}</p>
            <p className="flex items-center gap-2"><span>⏰</span> {tripResult.dinner.time}</p>
            <p className="flex items-center gap-2"><span>🚗</span> {tripResult.dinner.distance}</p>
          </div>
          <button className="w-full mt-3 py-2 border border-primary text-primary rounded-lg text-sm font-semibold">
            View Details
          </button>
        </div>

        {/* Stay Card */}
        <div className="bg-white rounded-xl p-4 mb-4 shadow-sm" data-testid="stay-card">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center">
              <span className="text-xl">🏨</span>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-gray-900">Stay</h3>
              <p className="text-sm text-primary font-medium">{tripResult.stay.name}</p>
            </div>
            <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">
              ⭐ {tripResult.stay.rating}
            </span>
          </div>
          <div className="text-sm text-gray-600 space-y-1">
            <p className="flex items-center gap-2"><span>📍</span> {tripResult.stay.location}</p>
            <p className="flex items-center gap-2"><span>⏰</span> Check-in: {tripResult.stay.checkIn}</p>
            <p className="flex items-center gap-2"><span>💰</span> {tripResult.stay.price}</p>
          </div>
          <button className="w-full mt-3 py-2 border border-primary text-primary rounded-lg text-sm font-semibold">
            View Details
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Plan Your Trip</h2>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Date of Journey */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Date of Journey
          </label>
          <input
            type="date"
            value={tripData.dateOfJourney}
            onChange={(e) => handleInputChange('dateOfJourney', e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-primary"
            required
            data-testid="date-input"
          />
        </div>

        {/* Start Time */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Start Time
          </label>
          <input
            type="time"
            value={tripData.startTime}
            onChange={(e) => handleInputChange('startTime', e.target.value)}
            className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-primary"
            required
            data-testid="time-input"
          />
        </div>

        {/* Start Location */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Start Location
          </label>
          <div className="flex items-center gap-2 mb-2">
            <input
              type="checkbox"
              id="useCurrentLocation"
              checked={tripData.useCurrentLocation}
              onChange={(e) => handleInputChange('useCurrentLocation', e.target.checked)}
              className="w-4 h-4 text-primary"
            />
            <label htmlFor="useCurrentLocation" className="text-sm text-gray-600">
              Use current location
            </label>
          </div>
          {!tripData.useCurrentLocation && (
            <input
              type="text"
              value={tripData.startLocation}
              onChange={(e) => handleInputChange('startLocation', e.target.value)}
              placeholder="Enter start location"
              className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-primary"
              required={!tripData.useCurrentLocation}
              data-testid="start-location-input"
            />
          )}
          {tripData.useCurrentLocation && (
            <div className="flex items-center gap-2 px-4 py-3 bg-green-50 rounded-xl text-green-700">
              <span>📍</span>
              <span className="text-sm">Using your current location</span>
            </div>
          )}
        </div>

        {/* Destination */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Destination
          </label>
          <input
            type="text"
            value={tripData.destination}
            onChange={(e) => handleInputChange('destination', e.target.value)}
            placeholder="Enter destination"
            className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-primary"
            required
            data-testid="destination-input"
          />
        </div>

        {/* Number of Persons */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Number of Persons
          </label>
          <div className="flex items-center justify-center gap-6">
            <button
              type="button"
              onClick={() => handleInputChange('numberOfPersons', Math.max(1, tripData.numberOfPersons - 1))}
              className="w-11 h-11 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-xl font-bold"
            >
              −
            </button>
            <div className="text-center">
              <p className="text-3xl font-bold" data-testid="persons-count">{tripData.numberOfPersons}</p>
              <p className="text-sm text-gray-500">{tripData.numberOfPersons === 1 ? 'Person' : 'Persons'}</p>
            </div>
            <button
              type="button"
              onClick={() => handleInputChange('numberOfPersons', Math.min(20, tripData.numberOfPersons + 1))}
              className="w-11 h-11 bg-primary rounded-lg flex items-center justify-center text-white text-xl font-bold"
            >
              +
            </button>
          </div>
        </div>

        {/* Vehicle Number */}
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Vehicle Number
          </label>
          <input
            type="text"
            value={tripData.vehicleNumber}
            onChange={(e) => handleInputChange('vehicleNumber', e.target.value.toUpperCase())}
            placeholder="e.g., DL 01 AB 1234"
            className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none focus:border-primary uppercase"
            data-testid="vehicle-input"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-primary text-white py-4 rounded-full font-semibold disabled:opacity-50 flex items-center justify-center gap-2"
          data-testid="plan-trip-button"
        >
          {isSubmitting ? (
            <>
              <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
              Planning Your Trip...
            </>
          ) : (
            <>
              🗺️ Plan My Trip
            </>
          )}
        </button>
      </form>
    </div>
  );
}

// Sidebar Navigation Component
function Sidebar({ isOpen, onClose, onNavigate, userRole }) {
  const menuItems = [
    { id: 'profile', icon: '👤', label: 'My Profile' },
    { id: 'ownerDashboard', icon: '🏢', label: 'Owner Dashboard' },
    { id: 'trips', icon: '🗺️', label: 'My Trips' },
    { id: 'orders', icon: '📦', label: 'My Orders' },
    { id: 'tripPlanner', icon: '🧭', label: 'Trip Planner' },
    { id: 'payments', icon: '💳', label: 'Payments' },
    { id: 'support', icon: '💬', label: 'Support' },
    { id: 'emergency', icon: '🚨', label: 'Emergency' },
    { id: 'settings', icon: '⚙️', label: 'Settings' },
    { id: 'registerDhaba', icon: '🏪', label: 'Register Dhaba' },
    { id: 'adminPanel', icon: '🛡️', label: 'Admin Panel', adminOnly: true },
  ];

  const visibleMenuItems = menuItems.filter(item => !item.adminOnly || ['app_admin', 'dhaba_admin', 'admin'].includes(userRole));

  // Track touch position for swipe gesture
  const touchStartX = React.useRef(null);
  
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  
  const handleTouchMove = (e) => {
    if (!touchStartX.current) return;
    
    const currentX = e.touches[0].clientX;
    const diff = touchStartX.current - currentX;
    
    // If swiped left more than 50px, close the sidebar
    if (diff > 50) {
      onClose();
      touchStartX.current = null;
    }
  };
  
  const handleTouchEnd = () => {
    touchStartX.current = null;
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay - click to close */}
      <div 
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.6)',
          zIndex: 40,
          backdropFilter: 'blur(4px)'
        }}
        onClick={onClose}
      />
      
      {/* Premium Sidebar - Dark header, White body */}
      <div 
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100%',
          width: '75%',
          maxWidth: '280px',
          zIndex: 50,
          background: '#FFFFFF',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Content */}
        <div style={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
          {/* Dark Header Section with Logo */}
          <div style={{ 
            padding: '32px 24px 24px 24px',
            background: 'linear-gradient(180deg, #1E1E1E 0%, #2D2D2D 100%)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <img 
                  src="/images/hiwaytrip-icon.png" 
                  alt="HiWayTrip" 
                  style={{ 
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <span 
                style={{ 
                  fontSize: '20px', 
                  fontWeight: '700', 
                  fontFamily: "'Manrope', sans-serif",
                  background: 'linear-gradient(135deg, #D4AF37 0%, #F5ECD8 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                HiWayTrip
              </span>
            </div>
          </div>

          {/* White Menu Items Section */}
          <div style={{ padding: '16px 16px', flex: 1, overflowY: 'auto', background: '#FFFFFF' }}>
            {visibleMenuItems.map((item, index) => (
              <div
                key={item.id}
                onClick={() => {
                  onNavigate(item.id);
                  onClose();
                }}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '14px', 
                  padding: '14px 12px',
                  cursor: 'pointer',
                  borderRadius: '12px',
                  marginBottom: '4px',
                  transition: 'all 0.2s ease',
                  background: 'transparent'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)'}
                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                data-testid={`sidebar-${item.id}`}
              >
                <span style={{ 
                  fontSize: '18px',
                  width: '36px',
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(212, 175, 55, 0.15)',
                  borderRadius: '10px'
                }}>{item.icon}</span>
                <span style={{ 
                  fontSize: '15px', 
                  color: '#1A1A1A',
                  fontWeight: '500',
                  fontFamily: "'Plus Jakarta Sans', sans-serif"
                }}>{item.label}</span>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div style={{ 
            padding: '20px 24px',
            borderTop: '1px solid #E5E7EB',
            background: '#FFFFFF'
          }}>
            <p style={{ 
              fontSize: '11px', 
              color: '#9CA3AF',
              textAlign: 'center',
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}>
              Version 1.0 • Premium Edition
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

// Home Screen - Service Options
function HomeScreen({ onSelectRestaurant, onViewBreakfast, breakfastCartCount, onNavigate, onSelectService, onBottomNav, userRole, onOpenOrderDetail }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const serviceOptions = [
    { id: 'food', icon: '🍽️', label: 'Food', color: 'bg-orange-300', description: 'Restaurants & Dhabas' },
    { id: 'fuel', icon: '⛽', label: 'Fuel', color: 'bg-red-300', description: 'Petrol & Diesel' },
    { id: 'washroom', icon: '🚻', label: 'Washroom', color: 'bg-blue-300', description: 'Clean Restrooms' },
    { id: 'stay', icon: '🏨', label: 'Stay', color: 'bg-purple-300', description: 'Hotels & Lodges' },
    { id: 'evCharging', icon: '🔌', label: 'EV Charging', color: 'bg-green-300', description: 'Electric Vehicle' },
    { id: 'emergency', icon: '🚨', label: 'Emergency', color: 'bg-red-400', description: 'SOS & Help' },
    { id: 'roadsideAssistance', icon: '🔧', label: 'Roadside Assistance', color: 'bg-yellow-300', description: 'Tow & Repair' },
  ];

  return (
    <div 
      className="min-h-screen pb-20"
      style={{
        background: 'linear-gradient(180deg, #1E1E1E 0%, #2D2D2D 50%, #1E1E1E 100%)'
      }}
    >
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        onNavigate={onNavigate}
        userRole={userRole}
      />

      {/* Premium Dark Header */}
      <div 
        style={{
          background: 'linear-gradient(180deg, #121212 0%, #1E1E1E 100%)',
          padding: '16px',
          borderBottom: '1px solid rgba(212, 175, 55, 0.15)'
        }}
      >
        <div className="flex items-center justify-between">
          {/* Hamburger Menu - Three lines in circle */}
          <div 
            onClick={() => setSidebarOpen(true)}
            style={{ 
              cursor: 'pointer', 
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.1)',
              borderRadius: '50%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(212, 175, 55, 0.3)'
            }}
            data-testid="hamburger-menu"
          >
            <div style={{ width: '16px', height: '2px', backgroundColor: '#D4AF37', marginBottom: '3px', borderRadius: '1px' }}></div>
            <div style={{ width: '16px', height: '2px', backgroundColor: '#D4AF37', marginBottom: '3px', borderRadius: '1px' }}></div>
            <div style={{ width: '16px', height: '2px', backgroundColor: '#D4AF37', borderRadius: '1px' }}></div>
          </div>
          
          {/* Location Search Bar */}
          <div className="flex-1 ml-3 mr-3">
            <LocationSearchBar />
          </div>
          
          {/* Cart Icon */}
          <div 
            style={{ 
              cursor: 'pointer', 
              position: 'relative',
              width: '40px',
              height: '40px',
              background: 'rgba(212, 175, 55, 0.1)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid rgba(212, 175, 55, 0.2)'
            }}
          >
            <span style={{ fontSize: '20px' }}>🛒</span>
            {breakfastCartCount > 0 && (
              <span style={{ 
                position: 'absolute', 
                top: '-4px', 
                right: '-4px', 
                background: 'linear-gradient(135deg, #D4AF37, #C5A028)',
                color: '#121212', 
                fontSize: '10px', 
                width: '18px', 
                height: '18px', 
                borderRadius: '50%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontWeight: 'bold',
                boxShadow: '0 2px 8px rgba(212, 175, 55, 0.4)'
              }}>
                {breakfastCartCount}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Active Orders — shown only when user has live orders */}
      <div style={{ paddingTop: '16px' }}>
        <ActiveOrdersCard onSelectOrder={onOpenOrderDetail} />
      </div>

      {/* Welcome Section */}
      <div className="p-4 pt-6">
        <h1 
          style={{ 
            fontSize: '1.75rem', 
            fontWeight: '700',
            fontFamily: "'Manrope', sans-serif",
            color: '#FFFFFF'
          }}
        >
          What do you need?
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.875rem', marginTop: '4px' }}>
          Services near your location
        </p>
      </div>

      {/* Service Options Grid - Premium Glass Cards */}
      <div className="px-4">
        <div 
          style={{ 
            background: 'rgba(255,255,255,0.05)',
            backdropFilter: 'blur(12px)',
            borderRadius: '20px',
            padding: '20px',
            border: '1px solid rgba(255,255,255,0.1)',
            display: 'grid', 
            gridTemplateColumns: 'repeat(4, 1fr)', 
            gap: '16px' 
          }}
        >
          {serviceOptions.map((service) => (
            <button
              key={service.id}
              onClick={() => onSelectService(service.id)}
              style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                background: 'none', 
                border: 'none', 
                cursor: 'pointer',
                transition: 'transform 0.2s ease'
              }}
              className="service-icon"
              data-testid={`service-${service.id}`}
            >
              <div 
                style={{ 
                  width: '56px', 
                  height: '56px', 
                  borderRadius: '16px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  background: 'rgba(212, 175, 55, 0.15)',
                  border: '1px solid rgba(212, 175, 55, 0.25)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }}
              >
                <span style={{ fontSize: '26px' }}>{service.icon}</span>
              </div>
              <span style={{ 
                fontSize: '10px', 
                color: 'rgba(255,255,255,0.8)', 
                marginTop: '8px', 
                textAlign: 'center', 
                fontWeight: '500',
                fontFamily: "'Plus Jakarta Sans', sans-serif"
              }}>
                {service.label}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Nearby Highlight - Premium Card */}
      <div className="p-4 mt-6">
        <h2 
          style={{ 
            fontSize: '1.125rem', 
            fontWeight: '600', 
            color: '#D4AF37', 
            marginBottom: '12px',
            fontFamily: "'Manrope', sans-serif"
          }}
        >
          Nearby Services
        </h2>
        <div 
          style={{
            background: 'rgba(255,255,255,0.05)',
            backdropFilter: 'blur(12px)',
            borderRadius: '16px',
            padding: '16px',
            border: '1px solid rgba(255,255,255,0.1)'
          }}
        >
          <div className="flex items-center gap-3">
            <div 
              style={{
                width: '52px',
                height: '52px',
                background: 'linear-gradient(135deg, rgba(212,175,55,0.2), rgba(212,175,55,0.1))',
                borderRadius: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(212, 175, 55, 0.2)'
              }}
            >
              <span style={{ fontSize: '24px' }}>🍽️</span>
            </div>
            <div className="flex-1">
              <h3 style={{ fontWeight: '600', color: '#FFFFFF', fontSize: '0.95rem' }}>Amrik Sukhdev Dhaba</h3>
              <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', marginTop: '2px' }}>2.5 km away • Open Now</p>
            </div>
            <span 
              style={{
                background: 'linear-gradient(135deg, #D4AF37, #C5A028)',
                color: '#121212',
                padding: '4px 10px',
                borderRadius: '8px',
                fontSize: '0.75rem',
                fontWeight: '700',
                display: 'flex',
                alignItems: 'center',
                gap: '2px'
              }}
            >
              ⭐ 4.8
            </span>
          </div>
        </div>
      </div>

      {/* Premium Bottom Navigation */}
      <div 
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(180deg, #1E1E1E 0%, #121212 100%)',
          borderTop: '1px solid rgba(212, 175, 55, 0.15)',
          display: 'flex',
          justifyContent: 'space-around',
          padding: '12px 0 16px 0',
          maxWidth: '28rem',
          margin: '0 auto'
        }}
      >
        {[
          { id: 'home', icon: '🏠', label: 'Home', active: true },
          { id: 'map', icon: '📍', label: 'Map', active: false },
          { id: 'orders', icon: '📋', label: 'Orders', active: false },
          { id: 'profile', icon: '👤', label: 'Profile', active: false },
        ].map((tab) => (
          <div
            key={tab.id}
            onClick={() => onBottomNav && onBottomNav(tab.id)}
            style={{ 
              cursor: 'pointer', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              padding: '4px 16px',
              borderRadius: '12px',
              background: tab.active ? 'rgba(212, 175, 55, 0.15)' : 'transparent',
              transition: 'all 0.2s ease'
            }}
          >
            <span style={{ 
              fontSize: '22px', 
              opacity: tab.active ? 1 : 0.5,
              filter: tab.active ? 'drop-shadow(0 2px 4px rgba(212,175,55,0.3))' : 'none'
            }}>
              {tab.icon}
            </span>
            <span style={{ 
              fontSize: '10px', 
              color: tab.active ? '#D4AF37' : 'rgba(255,255,255,0.5)', 
              marginTop: '4px',
              fontWeight: tab.active ? '600' : '400',
              fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}>
              {tab.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

// Trip Planner Screen (separate from home)
function TripPlannerScreen({ onBack, onViewBreakfast }) {
  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">Trip Planner</h1>
      </div>
      <TripPlanner onViewBreakfast={onViewBreakfast} />
    </div>
  );
}

// MapScreen is now imported from ./screens/MapScreen.jsx

// Food Service Screen
function FoodServiceScreen({ onBack, onSelectRestaurant }) {
  const [filter, setFilter] = useState('All');
  const filters = ['All', 'Pure Veg', 'Non-Veg', 'Open Now', 'Nearby'];
  
  return (
    <div className="min-h-screen bg-gray-50 pb-6">
      <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">Food & Restaurants</h1>
      </div>
      
      <div className="p-4">
        <div className="bg-white rounded-full flex items-center px-4 py-3 shadow-sm">
          <span className="text-gray-400 mr-2">🔍</span>
          <input placeholder="Search restaurants or dishes..." className="flex-1 outline-none text-sm" />
        </div>

        <div className="mt-4 flex gap-2 overflow-x-auto pb-2">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
                filter === f ? 'bg-primary text-white' : 'bg-white text-gray-700 border border-gray-200'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <h2 className="mt-6 text-xl font-bold text-gray-900">Nearby Restaurants</h2>

        <div className="mt-4">
          {restaurants.map((r) => (
            <RestaurantCard key={r.id} restaurant={r} onClick={() => onSelectRestaurant(r)} />
          ))}
        </div>
      </div>
    </div>
  );
}

// Restaurant Detail Screen
function RestaurantDetailScreen({ restaurant, onBack, onBookTable }) {
  const [cart, setCart] = useState({});

  const addToCart = (item) => {
    setCart({ ...cart, [item.id]: (cart[item.id] || 0) + 1 });
  };

  const removeFromCart = (item) => {
    if (cart[item.id] > 0) {
      setCart({ ...cart, [item.id]: cart[item.id] - 1 });
    }
  };

  const totalItems = Object.values(cart).reduce((a, b) => a + b, 0);
  const totalAmount = menuItems.reduce((sum, item) => sum + (cart[item.id] || 0) * item.price, 0);

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      <div className="relative">
        <img src={restaurant.image} alt={restaurant.name} className="w-full h-52 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '8px', position: 'absolute', top: '16px', left: '16px' }}>&lt;</button>
        <div className="absolute bottom-4 left-4 right-4 text-white">
          <h1 className="text-2xl font-bold">{restaurant.name}</h1>
          <p className="text-white/70">{restaurant.cuisine}</p>
        </div>
      </div>

      <div className="p-4">
        <div className="bg-white rounded-xl p-4 flex justify-around">
          <div className="text-center">
            <span className="text-primary">⭐</span>
            <span className="font-bold ml-1">{restaurant.rating}</span>
            <p className="text-xs text-gray-500">{restaurant.reviewCount} reviews</p>
          </div>
          <div className="text-center border-l border-r px-4">
            <span className="text-primary">📍</span>
            <span className="font-bold ml-1">{restaurant.distance}</span>
            <p className="text-xs text-gray-500">Distance</p>
          </div>
          <div className="text-center">
            <span className="text-primary">⏱️</span>
            <span className="font-bold ml-1">{restaurant.time}</span>
            <p className="text-xs text-gray-500">Time</p>
          </div>
        </div>

        <div className="mt-4 flex gap-3">
          <button onClick={onBookTable} className="flex-1 bg-primary text-white py-3 rounded-full font-semibold">
            🪑 Book Table
          </button>
          <button className="flex-1 border border-primary text-primary py-3 rounded-full font-semibold">
            📞 Call
          </button>
        </div>

        <h2 className="mt-6 text-xl font-bold">Menu</h2>

        <div className="mt-4 space-y-4">
          {menuItems.map((item) => (
            <div key={item.id} className="bg-white rounded-xl p-4 flex gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className={`w-4 h-4 border-2 rounded ${item.isVeg ? 'border-green-600' : 'border-red-600'}`}>
                    <span className={`block w-2 h-2 m-0.5 rounded-full ${item.isVeg ? 'bg-green-600' : 'bg-red-600'}`}></span>
                  </span>
                  {item.bestseller && <span className="bg-primary text-white text-[10px] px-2 py-0.5 rounded font-bold">BESTSELLER</span>}
                </div>
                <h3 className="font-semibold mt-2">{item.name}</h3>
                <p className="font-bold mt-1">₹{item.price}</p>
              </div>
              <div className="text-center">
                <img src={item.image} alt={item.name} className="w-24 h-20 object-cover rounded-lg" />
                {!cart[item.id] ? (
                  <button onClick={() => addToCart(item)} className="mt-2 border border-primary text-primary px-4 py-1 rounded font-bold text-sm">
                    ADD
                  </button>
                ) : (
                  <div className="mt-2 bg-primary text-white px-2 py-1 rounded flex items-center justify-between">
                    <button onClick={() => removeFromCart(item)}>−</button>
                    <span className="mx-2 font-bold">{cart[item.id]}</span>
                    <button onClick={() => addToCart(item)}>+</button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {totalItems > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex items-center justify-between shadow-lg">
          <div>
            <p className="text-gray-500 text-sm">{totalItems} items</p>
            <p className="text-xl font-bold">₹{totalAmount}</p>
          </div>
          <button className="bg-primary text-white px-8 py-3 rounded-full font-semibold">
            View Cart
          </button>
        </div>
      )}
    </div>
  );
}

// Table Booking Screen
function TableBookingScreen({ restaurant, onBack, onConfirm }) {
  const [guests, setGuests] = useState(2);
  const [selectedTime, setSelectedTime] = useState('12:00 PM');
  const times = ['11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '7:00 PM', '7:30 PM', '8:00 PM'];

  const today = new Date();
  const dates = [...Array(14)].map((_, i) => {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    return date;
  });
  const [selectedDate, setSelectedDate] = useState(dates[0]);

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      <div className="bg-white p-4 flex items-center gap-4 border-b">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">Book a Table</h1>
      </div>

      <div className="p-4">
        <div className="bg-white rounded-xl p-4 flex items-center gap-4">
          <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <span className="text-2xl">🍽️</span>
          </div>
          <div>
            <h3 className="font-semibold">{restaurant.name}</h3>
            <p className="text-sm text-gray-500">{restaurant.address}</p>
          </div>
        </div>

        <h2 className="mt-6 text-lg font-bold">Select Date</h2>
        <div className="mt-3 flex gap-2 overflow-x-auto pb-2">
          {dates.map((date) => (
            <button
              key={date.toISOString()}
              onClick={() => setSelectedDate(date)}
              className={`min-w-[60px] py-3 rounded-xl border ${
                selectedDate.toDateString() === date.toDateString()
                  ? 'bg-primary text-white border-primary'
                  : 'bg-white border-gray-200'
              }`}
            >
              <p className="text-xs opacity-70">{['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()]}</p>
              <p className="text-xl font-bold">{date.getDate()}</p>
              <p className="text-xs opacity-70">{['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][date.getMonth()]}</p>
            </button>
          ))}
        </div>

        <h2 className="mt-6 text-lg font-bold">Select Time</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {times.map((time) => (
            <button
              key={time}
              onClick={() => setSelectedTime(time)}
              className={`px-4 py-2 rounded-lg border ${
                selectedTime === time ? 'bg-primary text-white border-primary' : 'bg-white border-gray-200'
              }`}
            >
              {time}
            </button>
          ))}
        </div>

        <h2 className="mt-6 text-lg font-bold">Number of Guests</h2>
        <div className="mt-3 bg-white rounded-xl p-4 flex items-center justify-center gap-6">
          <button
            onClick={() => setGuests(Math.max(1, guests - 1))}
            className="w-11 h-11 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-xl"
          >
            −
          </button>
          <div className="text-center">
            <p className="text-3xl font-bold">{guests}</p>
            <p className="text-sm text-gray-500">{guests === 1 ? 'Guest' : 'Guests'}</p>
          </div>
          <button
            onClick={() => setGuests(Math.min(20, guests + 1))}
            className="w-11 h-11 bg-primary rounded-lg flex items-center justify-center text-white text-xl"
          >
            +
          </button>
        </div>

        <div className="mt-6 bg-white rounded-xl p-4">
          <h3 className="font-bold mb-3">Booking Summary</h3>
          <p className="flex items-center gap-2 text-sm mb-2">
            <span className="text-primary">📅</span>
            {selectedDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
          </p>
          <p className="flex items-center gap-2 text-sm mb-2">
            <span className="text-primary">⏰</span> {selectedTime}
          </p>
          <p className="flex items-center gap-2 text-sm">
            <span className="text-primary">👥</span> {guests} {guests === 1 ? 'Guest' : 'Guests'}
          </p>
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4">
        <button onClick={onConfirm} className="w-full bg-primary text-white py-4 rounded-full font-semibold">
          Confirm Booking
        </button>
      </div>
    </div>
  );
}

// Breakfast Detail Screen - Menu with Providers
function BreakfastDetailScreen({ breakfastData, cart, onBack, onAddToCart, onCheckout }) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [filter, setFilter] = useState('All');
  
  const filters = ['All', 'Veg Only', 'Bestsellers'];
  
  const filteredMenu = breakfastMenu.filter(item => {
    if (filter === 'Veg Only') return item.isVeg;
    if (filter === 'Bestsellers') return item.bestseller;
    return true;
  });

  const getCartQuantity = (itemId, providerId) => {
    const cartItem = cart.find(c => c.item.id === itemId && c.provider.id === providerId);
    return cartItem ? cartItem.quantity : 0;
  };

  const totalItems = cart.reduce((sum, c) => sum + c.quantity, 0);
  const totalAmount = cart.reduce((sum, c) => sum + (c.quantity * c.provider.price), 0);

  // Provider Selection Modal
  if (selectedItem) {
    return (
      <div className="min-h-screen bg-gray-50 pb-24">
        <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
          <button onClick={() => setSelectedItem(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
          <h1 className="text-lg font-bold">Select Provider</h1>
        </div>

        {/* Item Info */}
        <div className="p-4">
          <div className="bg-white rounded-xl overflow-hidden shadow-sm">
            <img src={selectedItem.image} alt={selectedItem.name} className="w-full h-40 object-cover" />
            <div className="p-4">
              <div className="flex items-center gap-2">
                <span className={`w-4 h-4 border-2 rounded ${selectedItem.isVeg ? 'border-green-600' : 'border-red-600'}`}>
                  <span className={`block w-2 h-2 m-0.5 rounded-full ${selectedItem.isVeg ? 'bg-green-600' : 'bg-red-600'}`}></span>
                </span>
                <h2 className="text-xl font-bold">{selectedItem.name}</h2>
              </div>
              <p className="text-sm text-gray-500 mt-2">{selectedItem.description}</p>
            </div>
          </div>

          <h3 className="mt-6 text-lg font-bold text-gray-900">Available at {selectedItem.providers.length} restaurants</h3>
          
          <div className="mt-4 space-y-3">
            {selectedItem.providers.map((provider) => {
              const qty = getCartQuantity(selectedItem.id, provider.id);
              return (
                <div 
                  key={provider.id} 
                  className={`bg-white rounded-xl p-4 shadow-sm border-2 transition-colors ${
                    selectedProvider?.id === provider.id ? 'border-primary' : 'border-transparent'
                  }`}
                  onClick={() => setSelectedProvider(provider)}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <h4 className="font-bold text-gray-900">{provider.name}</h4>
                        <span className="bg-green-600 text-white px-1.5 py-0.5 rounded text-xs font-bold">
                          ⭐ {provider.rating}
                        </span>
                      </div>
                      <div className="flex items-center gap-3 mt-1 text-sm text-gray-500">
                        <span>📍 {provider.distance}</span>
                        <span>⏱️ {provider.time}</span>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-xl font-bold text-primary">₹{provider.price}</p>
                    </div>
                  </div>
                  
                  {/* Add/Remove Buttons */}
                  <div className="mt-3 flex items-center justify-end">
                    {qty === 0 ? (
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          onAddToCart(selectedItem, provider, 1);
                        }}
                        className="px-6 py-2 bg-primary text-white rounded-lg font-semibold text-sm"
                        data-testid={`add-${selectedItem.id}-${provider.id}`}
                      >
                        ADD
                      </button>
                    ) : (
                      <div className="flex items-center gap-3 bg-primary rounded-lg px-2 py-1">
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            onAddToCart(selectedItem, provider, qty - 1);
                          }}
                          className="w-8 h-8 text-white font-bold text-lg"
                        >
                          −
                        </button>
                        <span className="text-white font-bold min-w-[20px] text-center">{qty}</span>
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            onAddToCart(selectedItem, provider, qty + 1);
                          }}
                          className="w-8 h-8 text-white font-bold text-lg"
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Cart Bar */}
        {totalItems > 0 && (
          <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex items-center justify-between shadow-lg max-w-md mx-auto">
            <div>
              <p className="text-gray-500 text-sm">{totalItems} item{totalItems > 1 ? 's' : ''}</p>
              <p className="text-xl font-bold">₹{totalAmount}</p>
            </div>
            <button 
              onClick={onCheckout}
              className="bg-primary text-white px-6 py-3 rounded-full font-semibold"
              data-testid="view-cart-btn"
            >
              View Cart
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-500 to-orange-500 p-4 pb-6">
        <div className="flex items-center gap-4">
          <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#ffffff', padding: '4px' }}>&lt;</button>
          <div>
            <h1 className="text-xl font-bold text-white">Breakfast Menu</h1>
            <p className="text-white/80 text-sm">🌅 Available at {breakfastData?.time || '8:00 AM'}</p>
          </div>
        </div>
      </div>

      {/* Recommended Stop */}
      {breakfastData && (
        <div className="px-4 -mt-3">
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center">
                <span className="text-xl">📍</span>
              </div>
              <div className="flex-1">
                <p className="text-xs text-gray-500">Recommended Stop</p>
                <p className="font-bold text-gray-900">{breakfastData.name}</p>
                <p className="text-sm text-gray-500">{breakfastData.location} • {breakfastData.distance}</p>
              </div>
              <span className="bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">
                ⭐ {breakfastData.rating}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="px-4 mt-4">
        <div className="flex gap-2 overflow-x-auto pb-2">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap ${
                filter === f ? 'bg-primary text-white' : 'bg-white text-gray-700 border border-gray-200'
              }`}
            >
              {f === 'Veg Only' && '🥬 '}{f}
            </button>
          ))}
        </div>
      </div>

      {/* Menu Items */}
      <div className="px-4 mt-4">
        <h2 className="text-lg font-bold text-gray-900 mb-3">Indian Breakfast Items</h2>
        
        <div className="space-y-4">
          {filteredMenu.map((item) => (
            <div 
              key={item.id} 
              className="bg-white rounded-xl overflow-hidden shadow-sm cursor-pointer"
              onClick={() => setSelectedItem(item)}
              data-testid={`menu-item-${item.id}`}
            >
              <div className="flex">
                <div className="flex-1 p-4">
                  <div className="flex items-center gap-2">
                    <span className={`w-4 h-4 border-2 rounded ${item.isVeg ? 'border-green-600' : 'border-red-600'}`}>
                      <span className={`block w-2 h-2 m-0.5 rounded-full ${item.isVeg ? 'bg-green-600' : 'bg-red-600'}`}></span>
                    </span>
                    {item.bestseller && (
                      <span className="bg-primary text-white text-[10px] px-2 py-0.5 rounded font-bold">BESTSELLER</span>
                    )}
                  </div>
                  <h3 className="font-bold text-gray-900 mt-2">{item.name}</h3>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">{item.description}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="text-sm font-bold text-primary">
                      From ₹{Math.min(...item.providers.map(p => p.price))}
                    </span>
                    <span className="text-xs text-gray-400">
                      • {item.providers.length} providers
                    </span>
                  </div>
                </div>
                <div className="w-28 relative">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                  <button 
                    className="absolute bottom-2 right-2 bg-white text-primary px-3 py-1 rounded font-bold text-sm shadow"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedItem(item);
                    }}
                  >
                    ORDER
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Cart Bar */}
      {totalItems > 0 && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 flex items-center justify-between shadow-lg max-w-md mx-auto">
          <div>
            <p className="text-gray-500 text-sm">{totalItems} item{totalItems > 1 ? 's' : ''}</p>
            <p className="text-xl font-bold">₹{totalAmount}</p>
          </div>
          <button 
            onClick={onCheckout}
            className="bg-primary text-white px-6 py-3 rounded-full font-semibold"
            data-testid="checkout-btn"
          >
            Proceed to Checkout
          </button>
        </div>
      )}
    </div>
  );
}

// Breakfast Checkout Screen
function BreakfastCheckoutScreen({ cart, onBack, onPlaceOrder, onUpdateCart }) {
  const [paymentMethod, setPaymentMethod] = useState('upi');
  const [isProcessing, setIsProcessing] = useState(false);
  
  const totalItems = cart.reduce((sum, c) => sum + c.quantity, 0);
  const subtotal = cart.reduce((sum, c) => sum + (c.quantity * c.provider.price), 0);
  const deliveryFee = 0; // Pickup only
  const taxes = Math.round(subtotal * 0.05); // 5% GST
  const total = subtotal + deliveryFee + taxes;

  // Group cart by provider
  const cartByProvider = cart.reduce((acc, item) => {
    const providerId = item.provider.id;
    if (!acc[providerId]) {
      acc[providerId] = {
        provider: item.provider,
        items: []
      };
    }
    acc[providerId].items.push(item);
    return acc;
  }, {});

  const handlePayment = () => {
    setIsProcessing(true);
    // Simulate payment processing
    setTimeout(() => {
      setIsProcessing(false);
      onPlaceOrder();
    }, 2000);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-48">
      {/* Header */}
      <div className="bg-white p-4 flex items-center gap-4 border-b sticky top-0 z-10">
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '20px', color: '#000000', padding: '4px' }}>&lt;</button>
        <h1 className="text-xl font-bold">Checkout</h1>
      </div>

      <div className="p-4">
        {/* Cart Items by Provider */}
        <h2 className="text-lg font-bold text-gray-900 mb-3">Your Order</h2>
        
        {Object.values(cartByProvider).map(({ provider, items }) => (
          <div key={provider.id} className="bg-white rounded-xl p-4 shadow-sm mb-4">
            <div className="flex items-center gap-2 mb-3 pb-3 border-b border-gray-100">
              <span className="text-lg">🏪</span>
              <div>
                <h3 className="font-bold text-gray-900">{provider.name}</h3>
                <p className="text-xs text-gray-500">Pickup in {provider.time}</p>
              </div>
            </div>
            
            {items.map(({ item, quantity }) => (
              <div key={`${item.id}-${provider.id}`} className="flex items-center justify-between py-2">
                <div className="flex items-center gap-3 flex-1">
                  <img src={item.image} alt={item.name} className="w-12 h-12 rounded-lg object-cover" />
                  <div>
                    <div className="flex items-center gap-1">
                      <span className={`w-3 h-3 border rounded ${item.isVeg ? 'border-green-600' : 'border-red-600'}`}>
                        <span className={`block w-1.5 h-1.5 m-0.5 rounded-full ${item.isVeg ? 'bg-green-600' : 'bg-red-600'}`}></span>
                      </span>
                      <p className="font-medium text-sm">{item.name}</p>
                    </div>
                    <p className="text-sm text-gray-500">₹{provider.price} each</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-2 py-1">
                    <button 
                      onClick={() => onUpdateCart(item, provider, quantity - 1)}
                      className="w-6 h-6 text-gray-600 font-bold"
                    >
                      −
                    </button>
                    <span className="font-bold min-w-[20px] text-center">{quantity}</span>
                    <button 
                      onClick={() => onUpdateCart(item, provider, quantity + 1)}
                      className="w-6 h-6 text-gray-600 font-bold"
                    >
                      +
                    </button>
                  </div>
                  <p className="font-bold min-w-[60px] text-right">₹{provider.price * quantity}</p>
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* Pickup Info */}
        <div className="bg-green-50 rounded-xl p-4 mb-4">
          <div className="flex items-center gap-3">
            <span className="text-2xl">🚗</span>
            <div>
              <h3 className="font-bold text-green-800">Pickup Order</h3>
              <p className="text-sm text-green-700">Your food will be ready for pickup at the restaurant</p>
            </div>
          </div>
        </div>

        {/* Payment Method */}
        <h2 className="text-lg font-bold text-gray-900 mb-3">Payment Method</h2>
        <div className="bg-white rounded-xl p-4 shadow-sm mb-4">
          {[
            { id: 'upi', name: 'UPI', icon: '📱', desc: 'GPay, PhonePe, Paytm' },
            { id: 'card', name: 'Credit/Debit Card', icon: '💳', desc: 'Visa, Mastercard, RuPay' },
            { id: 'cash', name: 'Cash on Pickup', icon: '💵', desc: 'Pay when you collect' },
          ].map((method) => (
            <label 
              key={method.id}
              className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer mb-2 last:mb-0 ${
                paymentMethod === method.id ? 'bg-primary/10 border-2 border-primary' : 'bg-gray-50'
              }`}
            >
              <input
                type="radio"
                name="payment"
                value={method.id}
                checked={paymentMethod === method.id}
                onChange={() => setPaymentMethod(method.id)}
                className="w-4 h-4 text-primary"
              />
              <span className="text-xl">{method.icon}</span>
              <div className="flex-1">
                <p className="font-semibold">{method.name}</p>
                <p className="text-xs text-gray-500">{method.desc}</p>
              </div>
            </label>
          ))}
        </div>

        {/* Bill Details */}
        <h2 className="text-lg font-bold text-gray-900 mb-3">Bill Details</h2>
        <div className="bg-white rounded-xl p-4 shadow-sm">
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Item Total ({totalItems} items)</span>
            <span className="font-medium">₹{subtotal}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Delivery Fee</span>
            <span className="font-medium text-green-600">FREE (Pickup)</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-gray-600">Taxes & Charges (5% GST)</span>
            <span className="font-medium">₹{taxes}</span>
          </div>
          <div className="flex justify-between py-3 border-t border-gray-200 mt-2">
            <span className="text-lg font-bold">Grand Total</span>
            <span className="text-lg font-bold text-primary">₹{total}</span>
          </div>
        </div>
      </div>

      {/* Place Order Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 shadow-lg max-w-md mx-auto">
        <div className="flex items-center justify-between mb-3">
          <span className="text-gray-600">Total Amount</span>
          <span className="text-xl font-bold">₹{total}</span>
        </div>
        <button 
          onClick={handlePayment}
          disabled={isProcessing || cart.length === 0}
          className="w-full bg-primary text-white py-4 rounded-full font-semibold disabled:opacity-50 flex items-center justify-center gap-2"
          data-testid="place-order-btn"
        >
          {isProcessing ? (
            <>
              <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
              Processing Payment...
            </>
          ) : (
            <>
              {paymentMethod === 'cash' ? '🛒 Confirm Order' : '💳 Pay ₹' + total}
            </>
          )}
        </button>
      </div>
    </div>
  );
}

// PlaceholderScreen, MyProfileScreen, MyTripsScreen, MyOrdersScreen, EmergencyScreen
// extracted to screens/UtilityScreens.jsx

// Main App
function App() {
  const [screen, setScreen] = useState('splash');
  const [user, setUser] = useState(null);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [preOrderEta, setPreOrderEta] = useState(null);
  const [preOrderInitialCart, setPreOrderInitialCart] = useState(null);
  const [breakfastData, setBreakfastData] = useState(null);
  const [breakfastCart, setBreakfastCart] = useState([]);
  const [pendingOrderDetailId, setPendingOrderDetailId] = useState(null);

  // Check for existing auth on mount
  useEffect(() => {
    const checkAuth = async () => {
      const { getStoredUser, getCurrentUser } = await import('./services/authService');
      const storedUser = getStoredUser();
      if (storedUser) {
        setUser(storedUser);
        // Optionally verify token is still valid
        const validUser = await getCurrentUser();
        if (validUser) {
          setUser(validUser);
        }
      }
    };
    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setScreen('home');
  };
  
  const handleLogout = async () => {
    const { logout } = await import('./services/authService');
    logout();
    setUser(null);
    setScreen('auth');
  };

  const handleSelectRestaurant = (r) => {
    setSelectedRestaurant(r);
    setScreen('restaurant');
  };
  
  const handleSelectDhaba = (dhaba) => {
    setSelectedRestaurant(dhaba);
    setScreen('dhabaDetail');
  };
  
  const handleBookTable = () => setScreen('booking');

  const handlePreOrder = (dhaba, etaMinutes, initialCart = null) => {
    setSelectedRestaurant(dhaba);
    setPreOrderEta(etaMinutes || 30);
    setPreOrderInitialCart(initialCart);
    setScreen('preOrder');
  };

  const handleConfirmBooking = () => {
    alert('Table booked successfully!');
    setScreen('home');
  };
  
  const handleViewBreakfast = (breakfast) => {
    setBreakfastData(breakfast);
    setScreen('breakfast');
  };
  
  const handleAddToBreakfastCart = (item, provider, quantity) => {
    const existingIndex = breakfastCart.findIndex(
      c => c.item.id === item.id && c.provider.id === provider.id
    );
    
    if (existingIndex >= 0) {
      const newCart = [...breakfastCart];
      newCart[existingIndex].quantity = quantity;
      if (quantity === 0) {
        newCart.splice(existingIndex, 1);
      }
      setBreakfastCart(newCart);
    } else if (quantity > 0) {
      setBreakfastCart([...breakfastCart, { item, provider, quantity }]);
    }
  };
  
  const handleBreakfastCheckout = () => {
    setScreen('breakfastCheckout');
  };
  
  const handlePlaceBreakfastOrder = () => {
    alert('Order placed successfully! Your breakfast will be ready for pickup.');
    setBreakfastCart([]);
    setScreen('home');
  };

  const handleSidebarNavigate = (itemId) => {
    switch(itemId) {
      case 'profile':
        setScreen('profile');
        break;
      case 'trips':
        setScreen('myTrips');
        break;
      case 'orders':
        setScreen('myOrders');
        break;
      case 'tripPlanner':
        setScreen('tripPlanner');
        break;
      case 'payments':
        setScreen('payments');
        break;
      case 'support':
        setScreen('support');
        break;
      case 'emergency':
        setScreen('emergency');
        break;
      case 'settings':
        setScreen('settings');
        break;
      case 'registerDhaba':
        setScreen('registerDhaba');
        break;
      case 'ownerDashboard':
        setScreen('ownerDashboard');
        break;
      case 'adminPanel':
        setScreen('adminPanel');
        break;
      default:
        setScreen('home');
    }
  };

  const handleSelectService = (serviceId) => {
    switch(serviceId) {
      case 'food':
        setScreen('food');
        break;
      case 'fuel':
        setScreen('fuel');
        break;
      case 'washroom':
        setScreen('washroom');
        break;
      case 'stay':
        setScreen('stay');
        break;
      case 'evCharging':
        setScreen('evCharging');
        break;
      case 'emergency':
        setScreen('emergency');
        break;
      case 'roadsideAssistance':
        setScreen('roadsideAssistance');
        break;
      default:
        break;
    }
  };

  return (
    <LocationProvider>
    <div className="max-w-md mx-auto min-h-screen bg-gray-100">
      {screen === 'splash' && <SplashScreen onComplete={() => setScreen('auth')} />}
      {screen === 'auth' && <AuthScreen onLogin={handleLogin} />}
      {screen === 'home' && (
        <HomeScreen 
          onSelectRestaurant={handleSelectRestaurant} 
          onViewBreakfast={handleViewBreakfast}
          breakfastCartCount={breakfastCart.reduce((sum, c) => sum + c.quantity, 0)}
          onNavigate={handleSidebarNavigate}
          onSelectService={handleSelectService}
          userRole={user?.role}
          onOpenOrderDetail={(orderId) => { setPendingOrderDetailId(orderId); setScreen('myOrders'); }}
          onBottomNav={(id) => {
            if (id === 'map') setScreen('map');
            else if (id === 'orders') setScreen('myOrders');
            else if (id === 'profile') setScreen('profile');
          }}
        />
      )}
      {screen === 'tripPlanner' && (
        <TripPlannerScreen
          onBack={() => setScreen('home')}
          onViewBreakfast={handleViewBreakfast}
        />
      )}
      {screen === 'registerDhaba' && (
        <DhabaRegistrationForm
          onBack={() => setScreen('home')}
          onSuccess={(result) => {
            setScreen('registrationSuccess');
          }}
        />
      )}
      {screen === 'registrationSuccess' && (
        <div style={{ minHeight: '100vh', background: '#FFFFFF', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
          <div style={{ textAlign: 'center', maxWidth: '340px' }}>
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'linear-gradient(135deg, #D4AF37, #C5A028)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '36px', color: '#1A1A1A' }}>✓</div>
            <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1A1A1A', fontFamily: "'Manrope', sans-serif", marginBottom: '8px' }}>Registration Submitted!</h1>
            <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '24px', lineHeight: '1.5' }}>
              Your dhaba registration has been submitted successfully and is awaiting admin approval. You will be notified once it's reviewed.
            </p>
            <div style={{ background: '#F9FAFB', borderRadius: '12px', padding: '16px', marginBottom: '24px' }}>
              <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '4px' }}>What happens next?</p>
              <p style={{ fontSize: '13px', color: '#374151' }}>Our team will review your submission and verify the details. This typically takes 24-48 hours.</p>
            </div>
            <button onClick={() => setScreen('home')} data-testid="go-home-btn"
              style={{ width: '100%', padding: '16px', borderRadius: '14px', border: 'none', background: 'linear-gradient(135deg, #D4AF37, #C5A028)', color: '#1A1A1A', fontWeight: '700', fontSize: '16px', cursor: 'pointer', marginBottom: '12px' }}>
              Go to Home
            </button>
            <button onClick={() => setScreen('ownerDashboard')} data-testid="go-dashboard-btn"
              style={{ width: '100%', padding: '14px', borderRadius: '14px', border: '2px solid #1A1A1A', background: 'transparent', color: '#1A1A1A', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}>
              View Owner Dashboard
            </button>
          </div>
        </div>
      )}
      {screen === 'ownerDashboard' && (
        <OwnerDashboard
          onBack={() => setScreen('home')}
          onRegister={() => setScreen('registerDhaba')}
          user={user}
        />
      )}
      {screen === 'adminPanel' && (
        <AdminPanel
          onBack={() => setScreen('home')}
          user={user}
        />
      )}
      {screen === 'dhabaDetail' && selectedRestaurant && (
        <DhabaDetailScreen
          dhaba={selectedRestaurant}
          onBack={() => setScreen('food')}
          onOrder={(dhaba, initialCart) => handlePreOrder(dhaba, 30, initialCart)}
        />
      )}
      {screen === 'preOrder' && selectedRestaurant && (
        <PreOrderScreen
          dhaba={selectedRestaurant}
          etaMinutes={preOrderEta}
          initialCart={preOrderInitialCart}
          onBack={() => { setPreOrderInitialCart(null); setScreen('dhabaDetail'); }}
          onOrderPlaced={() => { setPreOrderInitialCart(null); setScreen('home'); }}
        />
      )}
      {screen === 'map' && (
        <MapScreen
          onBack={() => setScreen('home')}
          onSelectDhaba={handleSelectDhaba}
          onPreOrder={handlePreOrder}
        />
      )}
      {screen === 'food' && (
        <FoodScreen
          onBack={() => setScreen('home')}
          onSelectDhaba={handleSelectDhaba}
        />
      )}
      {screen === 'fuel' && (
        <PlaceholderScreen 
          title="Fuel Stations" 
          icon="⛽" 
          description="Find nearby petrol and diesel stations"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'washroom' && (
        <PlaceholderScreen 
          title="Washrooms" 
          icon="🚻" 
          description="Find clean restrooms nearby"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'stay' && (
        <PlaceholderScreen 
          title="Stay & Hotels" 
          icon="🏨" 
          description="Find hotels and lodges nearby"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'evCharging' && (
        <PlaceholderScreen 
          title="EV Charging" 
          icon="🔌" 
          description="Find electric vehicle charging stations"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'roadsideAssistance' && (
        <PlaceholderScreen 
          title="Roadside Assistance" 
          icon="🔧" 
          description="Get help with towing and vehicle repairs"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'restaurant' && selectedRestaurant && (
        <RestaurantDetailScreen
          restaurant={selectedRestaurant}
          onBack={() => setScreen('home')}
          onBookTable={handleBookTable}
        />
      )}
      {screen === 'booking' && selectedRestaurant && (
        <TableBookingScreen
          restaurant={selectedRestaurant}
          onBack={() => setScreen('restaurant')}
          onConfirm={handleConfirmBooking}
        />
      )}
      {screen === 'breakfast' && (
        <BreakfastDetailScreen
          breakfastData={breakfastData}
          cart={breakfastCart}
          onBack={() => setScreen('home')}
          onAddToCart={handleAddToBreakfastCart}
          onCheckout={handleBreakfastCheckout}
        />
      )}
      {screen === 'breakfastCheckout' && (
        <BreakfastCheckoutScreen
          cart={breakfastCart}
          onBack={() => setScreen('breakfast')}
          onPlaceOrder={handlePlaceBreakfastOrder}
          onUpdateCart={handleAddToBreakfastCart}
        />
      )}
      {screen === 'profile' && (
        <MyProfileScreen onBack={() => setScreen('home')} />
      )}
      {screen === 'myTrips' && (
        <MyTripsScreen onBack={() => setScreen('home')} />
      )}
      {screen === 'myOrders' && (
        <MyOrdersScreen
          initialOrderId={pendingOrderDetailId}
          onBack={() => { setPendingOrderDetailId(null); setScreen('home'); }}
        />
      )}
      {screen === 'emergency' && (
        <EmergencyScreen onBack={() => setScreen('home')} />
      )}
      {screen === 'payments' && (
        <PlaceholderScreen 
          title="Payments" 
          icon="💳" 
          description="Manage your payment methods and view transaction history"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'support' && (
        <PlaceholderScreen 
          title="Support" 
          icon="💬" 
          description="Get help with your orders, trips, or account"
          onBack={() => setScreen('home')} 
        />
      )}
      {screen === 'settings' && (
        <PlaceholderScreen 
          title="Settings" 
          icon="⚙️" 
          description="Manage app settings and preferences"
          onBack={() => setScreen('home')} 
        />
      )}
    </div>
    </LocationProvider>
  );
}

export default App;
